export default {
  'approvalFiltersExternalUsers.form.row': 'External user filter',
  'approvalFiltersExternalUsers.form.addRow': 'Add external user filter',
  'approvalFiltersExternalUsers.form.noRows': 'No external user filters yet. Add at least one.',
};
